var cartQuantitySelects = [];

$(document).ready(function () {
    renderCart();
    $(document).on('change', '.cart-qty-input', onQuantityChange);
    $(document).on('click', '.cart-remove-btn', onRemove);
});

function getCart() {
    if (typeof MarketplaceCart !== 'undefined') {
        return MarketplaceCart.getCart();
    }
    try {
        var raw = localStorage.getItem('marketplace_cart');
        return raw ? JSON.parse(raw) : [];
    } catch (e) {
        return [];
    }
}

function saveCart(cart) {
    localStorage.setItem('marketplace_cart', JSON.stringify(cart));
    window.dispatchEvent(new CustomEvent('cartUpdated'));
    if (typeof MarketplaceCart !== 'undefined') {
        MarketplaceCart.updateHeaderCart();
    }
}

function removeItem(index) {
    var cart = getCart();
    if (index >= 0 && index < cart.length) {
        cart.splice(index, 1);
        saveCart(cart);
        renderCart();
    }
}

function updateQuantity(index, quantity) {
    var cart = getCart();
    if (index >= 0 && index < cart.length) {
        var qty = Math.max(1, parseInt(quantity, 10) || 1);
        cart[index].quantity = qty;
        saveCart(cart);
        setTimeout(function () {
            renderCart();
        }, 0);
    }
}

function onQuantityChange() {
    var $input = $(this);
    var index = parseInt($input.data('index'), 10);
    var qty = $input.val();
    updateQuantity(index, qty);
}

function onRemove() {
    var index = parseInt($(this).data('index'), 10);
    removeItem(index);
}

function escapeHtml(s) {
    if (!s) return '';
    var div = document.createElement('div');
    div.textContent = s;
    return div.innerHTML;
}

function formatPrice(amount, currency) {
    var n = parseFloat(amount) || 0;
    var c = (currency && String(currency).trim()) || 'USD';
    return c + ' ' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

function sumCartByCurrency(cart) {
    var sums = {};
    cart.forEach(function (item) {
        var c = (item.currency && String(item.currency).trim()) || 'USD';
        var line = (parseFloat(item.price) || 0) * (parseInt(item.quantity, 10) || 1);
        sums[c] = (sums[c] || 0) + line;
    });
    return sums;
}

function refreshCartFxEstimate(cart) {
    var $wrap = $('#cartFxEstimateWrap');
    if (!$wrap.length) {
        return;
    }

    $wrap.addClass('d-none');

    var dc =
        typeof getMarketplaceDisplayCurrency === 'function'
            ? getMarketplaceDisplayCurrency()
            : null;

    if (!dc) {
        return;
    }

    if (typeof cartShouldShowFxEstimate === 'function' && !cartShouldShowFxEstimate(cart, dc)) {
        return;
    }

    var lines = cart.map(function (item) {
        return {
            amount: (parseFloat(item.price) || 0) * (parseInt(item.quantity, 10) || 1),
            currency: (item.currency && String(item.currency).trim()) || 'USD'
        };
    });

    if (typeof fetchCartFxEstimate !== 'function') {
        return;
    }

    fetchCartFxEstimate(lines, dc, function (res) {
        if (!res) {
            return;
        }

        $('#cartFxDisplayCur').text(res.display_currency);
        $('#cartFxEstimateTotal').text(
            res.display_currency +
                ' ' +
                Number(res.total_display).toLocaleString('en-GB', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })
        );
        var fxDateRaw = res.fx_rate_date || '';
        var fxDateShown =
            typeof DateHelper !== 'undefined' && typeof DateHelper.formatLocalDateFromIso === 'function'
                ? DateHelper.formatLocalDateFromIso(fxDateRaw)
                : fxDateRaw;
        $('#cartFxRateDate').text(fxDateShown);
        $wrap.removeClass('d-none');
    });
}

function renderCart() {
    var cart = getCart();
    var $empty = $('#cartEmptyState');
    var $content = $('#cartContent');
    var $items = $('#cartItems');
    var $subtotal = $('#cartSubtotal');
    var $total = $('#cartPageTotal');

    if (cart.length === 0) {
        $empty.removeClass('d-none');
        $content.addClass('d-none');
        return;
    }

    $empty.addClass('d-none');
    $content.removeClass('d-none');

    if (typeof SlimSelect !== 'undefined') {
        for (var d = 0; d < cartQuantitySelects.length; d++) {
            if (cartQuantitySelects[d] && typeof cartQuantitySelects[d].destroy === 'function') {
                cartQuantitySelects[d].destroy();
            }
        }
        cartQuantitySelects = [];
    }

    var html = '';

    cart.forEach(function (item, index) {
        var price = parseFloat(item.price) || 0;
        var qty = parseInt(item.quantity, 10) || 1;
        var maxQty = (item.max_quantity != null && item.max_quantity > 0) ? parseInt(item.max_quantity, 10) : 20;
        maxQty = Math.min(20, Math.max(1, maxQty));
        if (qty > maxQty) {
            qty = maxQty;
            item.quantity = maxQty;
            saveCart(cart);
        }
        var lineTotal = price * qty;

        var productUrl = '/marketplace/product/' + (item.product_uid || '');
        var imgSrc = item.image || '/assets/img/company/not_available.webp';
        var variantText = item.variant_name ? '<div class="small text-muted">' + escapeHtml(item.variant_name) + '</div>' : '';

        html += '<div class="cart-item-row cart-item-card" data-index="' + index + '">';
        html += '<div class="cart-item-image flex-shrink-0 me-3">';
        html += '<a href="' + escapeHtml(productUrl) + '"><img src="' + escapeHtml(imgSrc) + '" alt="" class="rounded" style="width: 80px; height: 80px; object-fit: cover;" loading="lazy" onerror="this.src=\'/assets/img/company/not_available.webp\'"></a>';
        html += '</div>';
        html += '<div class="cart-item-details flex-grow-1 min-w-0">';
        html += '<a href="' + escapeHtml(productUrl) + '" class="fw-semibold text-dark text-decoration-none d-block">' + escapeHtml(item.product_name || 'Product') + '</a>';
        html += variantText;
        html += '<div class="mt-1 text-primary fw-semibold">' + formatPrice(price, item.currency) + ' each</div>';
        html += '</div>';
        html += '<div class="cart-item-actions d-flex align-items-center flex-shrink-0">';
        html += '<div class="cart-item-qty">';
        html += '<select id="cart-qty-' + index + '" class="form-select form-select-sm cart-qty-input" data-index="' + index + '" style="width: 70px;">';
        for (var i = 1; i <= maxQty; i++) {
            html += '<option value="' + i + '"' + (qty === i ? ' selected' : '') + '>' + i + '</option>';
        }
        html += '</select>';
        html += '</div>';
        html += '<div class="cart-item-total fw-semibold ms-3" style="min-width: 90px; text-align: right;">' + formatPrice(lineTotal, item.currency) + '</div>';
        html += '<div class="cart-item-remove ms-2">';
        html += '<button type="button" class="btn btn-outline-danger btn-sm cart-remove-btn" data-index="' + index + '" title="Remove"><i class="fa-solid fa-trash"></i></button>';
        html += '</div>';
        html += '</div>';
        html += '</div>';
    });

    $items.html(html);
    var byCur = sumCartByCurrency(cart);
    var curKeys = Object.keys(byCur);
    if (curKeys.length === 1) {
        $subtotal.text(formatPrice(byCur[curKeys[0]], curKeys[0]));
        $total.text(formatPrice(byCur[curKeys[0]], curKeys[0]));
    } else {
        var lines = curKeys.map(function (k) {
            return formatPrice(byCur[k], k);
        });
        $subtotal.html(lines.join('<br>'));
        $total.html(lines.join('<br>'));
    }

    if (typeof SlimSelect !== 'undefined') {
        for (var i = 0; i < cartQuantitySelects.length; i++) {
            if (cartQuantitySelects[i] && typeof cartQuantitySelects[i].destroy === 'function') {
                cartQuantitySelects[i].destroy();
            }
        }
        cartQuantitySelects = [];
        $items.find('.cart-qty-input').each(function () {
            var idx = parseInt($(this).data('index'), 10);
            var selectEl = this;
            var inst = new SlimSelect({
                select: selectEl,
                placeholder: 'Qty',
                settings: {
                    showSearch: false
                },
                events: {
                    afterChange: function (newVal) {
                        var val = null;
                        if (typeof newVal === 'string' || typeof newVal === 'number') {
                            val = newVal;
                        } else if (newVal && Array.isArray(newVal) && newVal.length) {
                            var first = newVal[0];
                            val = (first && (first.value !== undefined ? first.value : first.id)) || null;
                        } else if (newVal && newVal.value !== undefined) {
                            val = newVal.value;
                        }
                        if (val != null) {
                            updateQuantity(idx, val);
                        }
                    }
                }
            });
            cartQuantitySelects.push(inst);
        });
    }

    refreshCartFxEstimate(cart);
}